/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/SavedArticles/theme';

export const SavedArticlesTheme = theme;
